import CommonResponse from "../../models/CommonResponse";
import axios from "axios";
import BackendClient from "../../BackendClient";

export function setTerritorySpawnLocation(client: BackendClient): Promise<CommonResponse> {
    const headers = {
      'Authorization': `${client.getAuthEntity()} ${client.getAuthToken()}`,
    };

    return new Promise<CommonResponse>((resolve, reject) => {
      axios.post(`${client.getBackendUrl()}${BackendClient.SetTerritorySpawnLocation}`, {} ,{headers: headers})
        .then((response) => resolve(response.data))
        .catch((reason) => {
          console.log(`Exception when trying to setTerritorySpawnLocation: ${JSON.stringify(reason)}`)
          reject(reason);
        });
    });
  }